import * as React from 'react';
import { Header, Message, Loader, Segment, List } from 'semantic-ui-react';
import { useQuery } from '@tanstack/react-query';
import useCsrfFetchJson from './hooks/use_csrf_fetch';
import MudColoredText from './utils/mud_colors';

const OocChat = ({ apiPath }) => {
  const fetchJson = useCsrfFetchJson();
  const {
    data = [],
    isLoading,
    isError,
    error
  } = useQuery({
    queryKey: ['player', 'ooc_messages'],
    queryFn: () => fetchJson(apiPath),
    refetchInterval: 15000,
  });

  if (isLoading) {
    return <Loader active inline="centered">Loading OOC chat...</Loader>;
  }

  if (isError) {
    return (
      <Message negative>
        <Message.Header>Unable to load OOC chat</Message.Header>
        <p>{error.message}</p>
      </Message>
    );
  }

  return (
    <Segment>
      <Header as="h4">OOC Chat</Header>
      {data.length === 0 ? (
        <Message info>
          <Message.Header>No recent OOC messages</Message.Header>
        </Message>
      ) : (
        <List className='mud'>
          {data.map((entry) => (
            <List.Item key={entry.id}>
              <List.Content>
                <List.Header className='mud-inline'>
                  <MudColoredText text={entry.created_at} />
                </List.Header>
                <List.Description className="mud-inline">
                  <MudColoredText text={`&r(&WOOC&r) &W${entry.character || 'Unknown'}&w: &C${entry.message}&w`} />
                </List.Description>
              </List.Content>
            </List.Item>
          ))}
        </List>
      )}
    </Segment>
  );
};

export default OocChat;
